import * as dom from './wpstg-dom-utils.js';

/**
 * Enable side bar menu and set url on tab click
 */
export default class WpstgSidebarMenu {
  constructor() {
    this.init();
  }

  init() {
    this.wpstdStagingTab = document.querySelector('#wpstg--tab--toggle--staging');
    this.wpstdBackupTab = document.querySelector('#wpstg--tab--toggle--backup');
    this.wpstdSidebarMenu = document.querySelector('#toplevel_page_wpstg_clone');
    this.addEvents();

    setTimeout(() => {
      dom.loadingPlaceholder('hidden');
    }, 5000);
  }

  addEvents() {
    if (this.wpstdStagingTab !== null) {
      this.wpstdStagingTab.addEventListener('click', () => {
        dom.setLoadingPlaceholder();
        this.setPageUrl('wpstg_clone');
        this.setSidebarMenu('wpstg_clone');
      });
    }

    if (this.wpstdBackupTab !== null) {
      this.wpstdBackupTab.addEventListener('click', () => {
        dom.setLoadingPlaceholder().then(() => dom.loadingPlaceholder());
        this.setPageUrl('wpstg_backup');
        this.setSidebarMenu('wpstg_backup');
      });
    }
  }

  setPageUrl(page) {
    window.history.pushState(null, null, window.location.pathname + '?page=' + page);
  }

  setSidebarMenu(page) {
    const wpstgSidebarMenuElements = this.wpstdSidebarMenu.querySelector('ul').querySelectorAll('li');
    if (wpstgSidebarMenuElements.length > 0) {
      for (let i = 0; i < wpstgSidebarMenuElements.length; i++) {
        wpstgSidebarMenuElements[i].classList.remove('current');
        if (wpstgSidebarMenuElements[i].querySelector('a') !== null) {
          if (wpstgSidebarMenuElements[i].querySelector('a').getAttribute('href') ==='admin.php?page=' + page) {
            wpstgSidebarMenuElements[i].classList.add('current');
          }
        }
      }
    }
  }
}
